import { useAppSelector } from '../../store/hooks'

interface ToolCardProps {
  index: number
  toolKey: string
  label: string
  description?: string
  onClick: () => void
}

export default function ToolCard({ index, toolKey, label, description, onClick }: ToolCardProps) {
  const badges = useAppSelector((s) => s.ui.notificationBadges)
  const badgeMsg = badges[toolKey]

  return (
    <div
      className="cat-tool-card"
      onClick={onClick}
      data-testid={`tool-card-${toolKey}`}
    >
      <div
        className="cat-tool-num"
        style={{ color: 'var(--blue)' }}
        data-testid={`tool-card-num-${toolKey}`}
      >
        {index + 1}
      </div>
      <div className="cat-tool-info">
        <div className="cat-tool-name" data-testid={`tool-card-name-${toolKey}`}>
          {label}
          {badgeMsg && (
            <span className="tool-badge-msg" data-testid={`tool-badge-${toolKey}`}>
              {badgeMsg}
            </span>
          )}
        </div>
        {description && (
          <div className="cat-tool-desc" data-testid={`tool-card-desc-${toolKey}`}>
            {description}
          </div>
        )}
      </div>
      <div className="cat-tool-arrow" style={{ color: 'var(--blue)' }}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </div>
    </div>
  )
}
